import 'element-closest-polyfill'
import { ListView } from './component/product/list'

declare global {
  interface Window {
    searchSourceSubTypesHashMap: any;
  }
}

new ListView().init();